import { useState, useEffect, useCallback } from 'react';
import { FaStar, FaChevronLeft, FaChevronRight, FaQuoteLeft } from 'react-icons/fa';
import api, { getImageUrl } from '../services/api';

export default function Testimonials() {
  const [testimonials, setTestimonials] = useState([]);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/testimonials')
      .then(res => setTestimonials(Array.isArray(res.data) ? res.data : []))
      .catch(err => console.error('Testimonials fetch error:', err))
      .finally(() => setLoading(false));
  }, []);

  const count = testimonials.length;

  const goNext = useCallback(() => {
    setCurrent((prev) => (prev + 1) % count);
  }, [count]);

  const goPrev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + count) % count);
  }, [count]);

  // Auto-slide every 5 seconds
  useEffect(() => {
    if (count <= 1) return;
    const interval = setInterval(goNext, 5000);
    return () => clearInterval(interval);
  }, [count, goNext]);

  if (loading || count === 0) return null;

  const item = testimonials[current];

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="section-title">
          <h2>Müşteri Yorumları</h2>
          <p>Musterilerimizin bizim hakkimizda dusunceleri</p>
        </div>

        <div className="testimonials-slider">
          {count > 1 && (
            <button className="testimonials-arrow testimonials-arrow-left" onClick={goPrev} aria-label="Onceki">
              <FaChevronLeft />
            </button>
          )}

          <div className="testimonial-card">
            <div className="testimonial-quote-icon">
              <FaQuoteLeft />
            </div>

            <div className="testimonial-content">
              <p>{item.content}</p>
            </div>

            <div className="testimonial-stars">
              {Array.from({ length: 5 }, (_, i) => (
                <FaStar key={i} className={i < item.rating ? 'star-filled' : 'star-empty'} />
              ))}
            </div>

            <div className="testimonial-author">
              {item.image_path ? (
                <img
                  src={getImageUrl(item.image_path)}
                  alt={item.name}
                  className="testimonial-avatar"
                />
              ) : (
                <div className="testimonial-avatar testimonial-avatar-placeholder">
                  {item.name.charAt(0).toUpperCase()}
                </div>
              )}
              <div className="testimonial-author-info">
                <strong>{item.name}</strong>
                {item.title && <span>{item.title}</span>}
              </div>
            </div>
          </div>

          {count > 1 && (
            <button className="testimonials-arrow testimonials-arrow-right" onClick={goNext} aria-label="Sonraki">
              <FaChevronRight />
            </button>
          )}
        </div>

        {count > 1 && (
          <div className="testimonials-dots">
            {testimonials.map((_, i) => (
              <button
                key={i}
                className={`testimonials-dot ${i === current ? 'active' : ''}`}
                onClick={() => setCurrent(i)}
                aria-label={`Yorum ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
